/** @module polyfills */

import { eventListenerOptions } from './event-listener-options';

/**
 * Polyfills CSS property object-fit when used with images.
 * To work properly, elements intended to be used with object-fit property need to have class <code>object-fit</code> set to their parent.
 * The polyfill selects an image from src- or data-src (for async images) attribute or uses the one provided by data attribute <code>data-objectfit</code>, applies it to the parent's background and sets class <code>compat-object-fit</code>.
 *
 * @param {HTMLElement} [el=null} - Optional element to use as root to look for elements containing <code>object-fit</code> class.
 */
export async function objectFit(el = null) {
    if (!('object-fit' in document.body.style)) {
        let { initObjectFit } = await import(/* webpackMode: "eager" */ './inc/object-fit.async');

        // due to async loading, the DOMContentLoaded event is probably already triggered
        if (
            document.readyState === 'complete' ||
            document.readyState === 'loaded' ||
            document.readyState === 'interactive'
        ) {
            initObjectFit(el);
        } else {
            document.addEventListener(
                'DOMContentLoaded',
                () => {
                    initObjectFit(el);
                },
                eventListenerOptions({ passive: true }),
            );
        }
    }
}
